import { render, staticRenderFns } from "./DataUpload.vue?vue&type=template&id=b84bdce0&scoped=true&"
import script from "./DataUpload.vue?vue&type=script&lang=js&"
export * from "./DataUpload.vue?vue&type=script&lang=js&"
import style0 from "./DataUpload.vue?vue&type=style&index=0&id=b84bdce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84bdce0",
  null
  
)

export default component.exports